/* SplashStrong: animaciones + confianza y promo en carrito lateral */
(function () {
  var root = document.documentElement;
  root.classList.add('ss-js');
  if (window.Shopify && window.Shopify.designMode) root.classList.add('ss-design');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function scan(scope) {
    (scope || document).querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  function promoHTML(n) {
    var r = n % 3, gratis = Math.floor(n / 3), faltan = 3 - r;
    var done = r === 0 && n > 0;
    var pct = done ? 100 : Math.round(r * 100 / 3);
    var txt;
    if (n === 0) txt = '<strong>Compra 2 y lleva 3:</strong> el 3º diseño es gratis.';
    else if (done) txt = '<strong>¡Listo!</strong> Tienes ' + gratis + (gratis === 1 ? ' producto gratis' : ' productos gratis') + ' en tu carrito.';
    else txt = 'Agrega <strong>' + faltan + (faltan === 1 ? ' producto más' : ' productos más') + '</strong> y el 3º es <strong>GRATIS</strong>.';
    return '<div class="ss-promo-progress' + (done ? ' is-done' : '') + '" data-count="' + n + '"><p class="ss-promo-progress__text"><span class="ss-promo-progress__gift" aria-hidden="true">🎁</span><span>' + txt + '</span></p><div class="ss-promo-progress__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div></div>';
  }

  var lastCount = null, busy = false;
  function updateDrawerPromo(force) {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || busy) return;
    var existing = footer.querySelector('.ss-promo-progress');
    if (existing && !force) return;
    busy = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var f = document.querySelector('#CartDrawer .drawer__footer');
        if (!f) return;
        var old = f.querySelector('.ss-promo-progress');
        if (old) old.remove();
        f.insertAdjacentHTML('afterbegin', promoHTML(cart.item_count));
        lastCount = cart.item_count;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function injectTrust() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    var tpl = document.getElementById('ss-drawer-trust');
    if (footer && tpl && !footer.querySelector('.ss-trust')) footer.appendChild(tpl.content.cloneNode(true));
    if (footer && !footer.querySelector('.ss-promo-progress')) updateDrawerPromo(true);
  }

  function init() {
    scan();
    injectTrust();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) new MutationObserver(injectTrust).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { updateDrawerPromo(true); });
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { updateDrawerPromo(true); }, 150); }); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  setTimeout(function () { document.querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
    var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in');
  }); }, 2500);
})();
